import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@packages/ui/shared';
import { createUseStyles } from 'react-jss';
import { SkeletonLoader } from '@web/components/skeleton-loader';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const useStyles = createUseStyles({
    dataCardHeading: {
        backgroundColor: '#F8F8F8',
        borderBottom: '1px solid #E3E3E3',
        padding: '12px 16px',
        height: 56,
        boxSizing: 'border-box',
        gap: 12,
    },
    headerTitle: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minWidth: 0,
        flexShrink: 1,
        flexBasis: '60%',
    },
    loaderLeft: {
        maxWidth: '65%',
    },
    loaderRight: {
        maxWidth: '25%',
    },
    customTooltip: {
        fontSize: 12,
        padding: '8px 12px',
        textAlign: 'center',
        marginTop: '-4px !important',
    },
});

interface DataCardHeaderProps {
    headerBadge?: React.ReactNode;
    headerText: string;
    finalBatteryTestDecision?: string;
    loading?: boolean;
}

export const DataCardHeader: FC<DataCardHeaderProps> = ({ headerBadge = null, headerText, loading = false }) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <div>
            {loading ? (
                <div
                    className={`d-flex justify-content-between align-items-center w-100 flex-wrap ${classes.dataCardHeading}`}
                    data-testid="data-card-header-loading"
                >
                    <SkeletonLoader type="text" className={classes.loaderLeft} />
                    <SkeletonLoader type="text" className={classes.loaderRight} />
                </div>
            ) : (
                <div
                    className={`d-flex justify-content-between align-items-center w-100 flex-nowrap ${classes.dataCardHeading}`}
                    data-testid="data-card-header"
                >
                    <>
                        <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip id="header-tooltip" className={classes.customTooltip}>
                                    {t(headerText)}
                                </Tooltip>
                            }
                        >
                            <span className={classes.headerTitle}>
                                <Typography variant="label" numberOfLines={1}>
                                    {t(headerText)}
                                </Typography>
                            </span>
                        </OverlayTrigger>
                        <div style={{ flexShrink: 1, minWidth: 0, maxWidth: '40%', overflow: 'hidden' }}>
                            {headerBadge || ''}
                        </div>
                    </>
                </div>
            )}
        </div>
    );
};
